import { render } from "./Unit_Transfers.vue?vue&type=template&id=5ea7a9bd"
import script from "./Unit_Transfers.vue?vue&type=script&lang=js"
export * from "./Unit_Transfers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__